let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gURfF")).then(() => parcelRequire('fgEX0'));